import React from 'react';

import wrapper from '../../redux';

import FreeCoursesContainer from '../../container/FreeCourses';

const index = () => <FreeCoursesContainer />;

export const getServerSideProps = wrapper.getServerSideProps(() => async () => ({
  props: {
    footer: { hide: true },
  },
}));

export default index;
